{
  "$comment": "Generated by curation/scripts/publish.mjs from human-approved curation/records. Don't edit by hand.",
  "collections": [
    {
      "slug": "start-here",
      "list": {
        "v": 1,
        "name": "Start Here",
        "author": "Multiverse Video editors",
        "description": "Ten accessible videos, each with one concrete next action.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://framatube.org/videos/watch/4294a720-f263-4ea4-9392-cf9cea4d5277",
            "note": "Framasoft's short, translated explainer of the Fediverse: many independent servers that talk to each other, like email.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.canadiancivil.com/videos/watch/8464439a-e53f-44b6-9eae-7f7ef6c9abb0",
            "note": "A clear introduction to housing co-ops: how residents own and run their buildings together, and why it keeps rents down.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/9c9de5e8-0a1e-484a-b099-e80766180a6d",
            "note": "Framasoft's two-minute explainer of PeerTube, the federated video platform this app reads from, with subtitles in 30+ languages.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.dair-institute.org/videos/watch/8df10458-1cb9-4b25-8d56-4510ad143559",
            "note": "Three minutes presenting DAIR's report on Amazon delivery drivers: how workplace surveillance tech is used to cut pay and hide responsibility.",
            "addedAt": 1792468565
          },
          {
            "id": "https://techlore.tv/videos/watch/e48c10f6-767f-47b7-92e9-543a61b37268",
            "note": "A plain-language walkthrough of threat modeling: who might want your data, what they could do with it, and which protections are worth your effort.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.apc.org/videos/watch/07ce15de-5f9a-490b-b9f2-e3ac13ea2d26",
            "note": "The story of B4RN, a community-built fibre network in rural England that has connected over 7,000 homes through joint action, with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/7ebdc562-2985-4de0-b262-5f07fc103fad",
            "note": "Artist bleeptrack's workshop on coding your own generative art with paper.js, from first shape to a piece that surprises you.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/aa8863b9-b2e1-4acd-ac9e-e917e1ff5fb1",
            "note": "Two minutes from unboxing to running code: installing MicroPython on a tiny ESP32-C3 board.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tilvids.com/videos/watch/fdefceaf-3690-4458-8852-b08c363b02ef",
            "note": "Veronica Explains pushes back on tech's habit of shaming people's hardware and software choices: your tools are probably fine.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.eqver.se/videos/watch/966f390f-8095-4c39-8c71-a7a8dbfb3e76",
            "note": "Five concrete email-security rules from a digital-security hotline expert, framed around the phishing campaigns that target journalists and activists.",
            "addedAt": 1792468565
          }
        ]
      }
    },
    {
      "slug": "hack-the-planet",
      "list": {
        "v": 1,
        "name": "Hack the Planet",
        "author": "Multiverse Video editors",
        "description": "Understand systems well enough to defend, repair, and improve them.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://techlore.tv/videos/watch/e48c10f6-767f-47b7-92e9-543a61b37268",
            "note": "A plain-language walkthrough of threat modeling: who might want your data, what they could do with it, and which protections are worth your effort.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/012c1f18-5e08-403e-af02-58cf2deedfe0",
            "note": "A hackerspace workshop on hardware hacking for absolute beginners: how to open a device, find its debug ports, and learn what's inside.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.publicspaces.net/videos/watch/ddce35a2-978d-423e-8474-4f366fabd9fc",
            "note": "A podcast episode with European Digital Rights on the trade-off between online safety laws and privacy, from the PublicSpaces coalition.",
            "addedAt": 1792468565
          },
          {
            "id": "https://techlore.tv/videos/watch/cc032cbd-ba6e-4e80-ac43-7efef73937f8",
            "note": "One short lesson from Techlore's free Go Incognito course: what actually protects your traffic on a network, and what doesn't.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/536b2ab8-8349-479f-b874-6babd38b3d8f",
            "note": "Crowd Supply's Teardown Sessions talks with Michael Altfield, maker of BusKill, a laptop kill-cord, about practical OpSec and privacy hardware.",
            "addedAt": 1792468565
          },
          {
            "id": "https://videos.spacebar.ca/videos/watch/6731b7ab-72b2-446b-9c00-957575912326",
            "note": "A NorthSec talk on fitting threat modeling into fast development cycles, so security questions get asked while the design can still change.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.eqver.se/videos/watch/966f390f-8095-4c39-8c71-a7a8dbfb3e76",
            "note": "Five concrete email-security rules from a digital-security hotline expert, framed around the phishing campaigns that target journalists and activists.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.tchncs.de/videos/watch/309d07f9-92fc-4f0f-aafc-3f8620f9f347",
            "note": "Shows how the Wi-Fi network names your devices broadcast can be mapped back to a home address, then what you can do about it.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.opencloud.lu/videos/watch/d683ebd8-49c8-4d8e-a410-c8391e26450f",
            "note": "A talk from CIRCL's MISP training channel on putting the open-source MISP threat-intelligence platform to work inside an incident response plan.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.infosec.exchange/videos/watch/eea8df79-1558-4ab8-bea6-45ae79430aee",
            "note": "A step-by-step solve of a crackmes.one reverse-engineering challenge, narrated so you can follow the reasoning, not just the answer.",
            "addedAt": 1792468565
          }
        ]
      }
    },
    {
      "slug": "the-machine-is-political",
      "list": {
        "v": 1,
        "name": "The Machine Is Political",
        "author": "Multiverse Video editors",
        "description": "Examine how technological systems allocate power, risk, and opportunity.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://peertube.dair-institute.org/videos/watch/8df10458-1cb9-4b25-8d56-4510ad143559",
            "note": "Three minutes presenting DAIR's report on Amazon delivery drivers: how workplace surveillance tech is used to cut pay and hide responsibility.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.dair-institute.org/videos/watch/071d3a21-8029-489e-ba7c-050cc6df3f3f",
            "note": "Mystery AI Hype Theater 3000, from DAIR's own instance, picks apart the claim that automation can strengthen democracy.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.anduin.net/videos/watch/ec7b69ba-6df8-4798-b651-0019fd4a608c",
            "note": "curl maintainer Daniel Stenberg at foss-north 2026 on what AI tools are really doing to open-source projects, from someone on the receiving end.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.opencloud.lu/videos/watch/9347074e-0019-4d39-aed6-76692621a17e",
            "note": "A talk on the Open Source AI Definition one year on: which 'open' models really are, and how to spot open-washing.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tv.lumbung.space/videos/watch/206dc46c-a6bd-4d93-aa33-65648a05cc8a",
            "note": "A CounterSpy conference talk from the Co-op Cloud project on platform surveillance and how cooperatives can run their own infrastructure instead.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.publicspaces.net/videos/watch/ddce35a2-978d-423e-8474-4f366fabd9fc",
            "note": "A podcast episode with European Digital Rights on the trade-off between online safety laws and privacy, from the PublicSpaces coalition.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.waag.org/videos/watch/4eac97f8-9604-4acd-a75c-e001297dc7ac",
            "note": "Waag Futurelab's yearly State of the Internet lecture, 2026 edition, given in English by Fieke Jansen with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.rhizome.org/videos/watch/5abcf089-0898-4d2b-a45d-65d02e39b69d",
            "note": "Rhizome's panel on the ethics of archiving digital folklore: memes, image macros, and who gets a say when the web's culture is preserved.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.dair-institute.org/videos/watch/e82a39c5-90d1-4f60-ad20-02a85a95ce00",
            "note": "Members of the Kenya-based Data Labelers Association describe the human labor behind AI training data, and how they're organizing.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/1b7027e5-6e45-4876-9833-4778de60b44f",
            "note": "Nathan Proctor of the US PIRG on the right-to-repair fight and how copyright law (the DMCA) gets used to stop you fixing your own things.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/dacd068d-3c10-49ed-a4b2-147ace22af94",
            "note": "Cory Doctorow's talk The Post-American Internet, posted with captions by Framasoft: an argument for interoperability as the way out of platform lock-in.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/e05ef9e8-b864-4c6b-8679-be8083169f50",
            "note": "A LibrePlanet 2023 panel on why mainstream platforms are free of charge, what that costs the Global South, and what a libre alternative looks like.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.kockatoo.org/videos/watch/38e4df20-0bb9-43ae-8fe8-edb2f3eb8012",
            "note": "Grant makers and builders debate who should fund technology that's given away for free, and which tech deserves public money.",
            "addedAt": 1792468565
          },
          {
            "id": "https://videos.lescommuns.org/videos/watch/2421852f-0337-4488-abdb-b762f7d89399",
            "note": "A university seminar on digital governance frameworks for AI, from the team behind OpenFisca, the open-source rules-as-code engine.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.apc.org/videos/watch/4001443d-9758-45f2-98d2-f9fe53167794",
            "note": "A four-minute APC short on where digital rights and environmental justice meet, with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tv.undersco.re/videos/watch/cb8fefbb-60a1-4475-aeff-1da8c93760e1",
            "note": "New Design Congress on the 'para-real': how decentralised networks of care form when official systems fail people.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.waag.org/videos/watch/76ec6be9-502c-4a0d-98e1-a2c4f6991308",
            "note": "Artist Špela Petrič presents The Archive of In-Operables, made during a residency at Waag Futurelab: strange, thoughtful art at the edge of biology and tech.",
            "addedAt": 1792468565
          }
        ]
      }
    },
    {
      "slug": "build-your-own-future",
      "list": {
        "v": 1,
        "name": "Build Your Own Future",
        "author": "Multiverse Video editors",
        "description": "Replace dependence on opaque platforms with skills and infrastructure you control.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://framatube.org/videos/watch/4294a720-f263-4ea4-9392-cf9cea4d5277",
            "note": "Framasoft's short, translated explainer of the Fediverse: many independent servers that talk to each other, like email.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/9c9de5e8-0a1e-484a-b099-e80766180a6d",
            "note": "Framasoft's two-minute explainer of PeerTube, the federated video platform this app reads from, with subtitles in 30+ languages.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/81f8d42e-e7ff-4635-943f-87abfdbc9820",
            "note": "A LibrePlanet 2024 talk on self-hosting that lasts: how to save, serve and safely back up your own data for years, not weekends.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.apc.org/videos/watch/07ce15de-5f9a-490b-b9f2-e3ac13ea2d26",
            "note": "The story of B4RN, a community-built fibre network in rural England that has connected over 7,000 homes through joint action, with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.exo.cat/videos/watch/67d9dc89-db96-48f5-8317-f7bba4849358",
            "note": "From Battlemesh v15: how the COWMesh community network brought connectivity to a rural area in India, built and run by locals.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.anduin.net/videos/watch/ec7b69ba-6df8-4798-b651-0019fd4a608c",
            "note": "curl maintainer Daniel Stenberg at foss-north 2026 on what AI tools are really doing to open-source projects, from someone on the receiving end.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.opencloud.lu/videos/watch/9347074e-0019-4d39-aed6-76692621a17e",
            "note": "A talk on the Open Source AI Definition one year on: which 'open' models really are, and how to spot open-washing.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tv.lumbung.space/videos/watch/206dc46c-a6bd-4d93-aa33-65648a05cc8a",
            "note": "A CounterSpy conference talk from the Co-op Cloud project on platform surveillance and how cooperatives can run their own infrastructure instead.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tilvids.com/videos/watch/fccf3369-f9b9-49f4-bd52-0a778d451f49",
            "note": "Build a chatbot character inside a Godot game that talks to a language model running on your own machine through Ollama.",
            "addedAt": 1792468565
          },
          {
            "id": "https://cuddly.tube/videos/watch/1a077c7c-4f26-404e-8fcf-9ab701b199de",
            "note": "Lessons from building a networking stack for microcontrollers with 32 kB of RAM, in Go.",
            "addedAt": 1792468565
          },
          {
            "id": "https://techlore.tv/videos/watch/cc032cbd-ba6e-4e80-ac43-7efef73937f8",
            "note": "One short lesson from Techlore's free Go Incognito course: what actually protects your traffic on a network, and what doesn't.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.blender.org/videos/watch/5ca2bd96-8de7-4cb2-af6c-b85201b3002b",
            "note": "From the Blender Conference 2026: procedural workflows with Gaussian splatting, the new way to turn photos into 3D scenes.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/dacd068d-3c10-49ed-a4b2-147ace22af94",
            "note": "Cory Doctorow's talk The Post-American Internet, posted with captions by Framasoft: an argument for interoperability as the way out of platform lock-in.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tubefree.org/videos/watch/0d612d2a-4c5b-43b9-ade9-2b7643abd0ce",
            "note": "A long conversation with Evan Prodromou, an architect of ActivityPub, the protocol behind the Fediverse, on why it was built for people first.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.tchncs.de/videos/watch/d7d5b093-3491-4bd5-8ab0-92cf783b1775",
            "note": "The Bonfire project on federated digital spaces built for mutual aid networks, as an alternative to running them on corporate group chats.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.osgeo.org/videos/watch/86a4f7b0-fbcd-4a98-b9d7-8ab9a98d4367",
            "note": "A FOSS4G talk on interactive open-source tools for visualizing climate risk, used in disaster-reduction programmes.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/e05ef9e8-b864-4c6b-8679-be8083169f50",
            "note": "A LibrePlanet 2023 panel on why mainstream platforms are free of charge, what that costs the Global South, and what a libre alternative looks like.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.kockatoo.org/videos/watch/38e4df20-0bb9-43ae-8fe8-edb2f3eb8012",
            "note": "Grant makers and builders debate who should fund technology that's given away for free, and which tech deserves public money.",
            "addedAt": 1792468565
          },
          {
            "id": "https://videos.spacebar.ca/videos/watch/6731b7ab-72b2-446b-9c00-957575912326",
            "note": "A NorthSec talk on fitting threat modeling into fast development cycles, so security questions get asked while the design can still change.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tilvids.com/videos/watch/78036a7d-ff69-4657-a501-8232cad8491d",
            "note": "A persuasive case that everyone should run a home server, or have a friend who does, and what that buys you.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tilvids.com/videos/watch/fdefceaf-3690-4458-8852-b08c363b02ef",
            "note": "Veronica Explains pushes back on tech's habit of shaming people's hardware and software choices: your tools are probably fine.",
            "addedAt": 1792468565
          },
          {
            "id": "https://videos.trom.tf/videos/watch/64d4b2b2-c5b3-4491-af8a-80d4f152c1f3",
            "note": "A Hackerspace Brussels talk on using free software to build your own autonomous robots.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.kaleidos.net/videos/watch/fcdab2ef-54d1-45da-b2c4-6954d082e849",
            "note": "A short interview on why teams are self-hosting their design tools, using Penpot as the example.",
            "addedAt": 1792468565
          }
        ]
      }
    },
    {
      "slug": "reclaim-the-city",
      "list": {
        "v": 1,
        "name": "Reclaim the City",
        "author": "Multiverse Video editors",
        "description": "Learn how people redesign the systems that shape daily life.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://video.canadiancivil.com/videos/watch/8464439a-e53f-44b6-9eae-7f7ef6c9abb0",
            "note": "A clear introduction to housing co-ops: how residents own and run their buildings together, and why it keeps rents down.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.dair-institute.org/videos/watch/8df10458-1cb9-4b25-8d56-4510ad143559",
            "note": "Three minutes presenting DAIR's report on Amazon delivery drivers: how workplace surveillance tech is used to cut pay and hide responsibility.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.apc.org/videos/watch/07ce15de-5f9a-490b-b9f2-e3ac13ea2d26",
            "note": "The story of B4RN, a community-built fibre network in rural England that has connected over 7,000 homes through joint action, with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.exo.cat/videos/watch/67d9dc89-db96-48f5-8317-f7bba4849358",
            "note": "From Battlemesh v15: how the COWMesh community network brought connectivity to a rural area in India, built and run by locals.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.waag.org/videos/watch/4eac97f8-9604-4acd-a75c-e001297dc7ac",
            "note": "Waag Futurelab's yearly State of the Internet lecture, 2026 edition, given in English by Fieke Jansen with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.canadiancivil.com/videos/watch/3e4074e9-6b68-499d-a76f-537342fd2c79",
            "note": "A practical guide to tenant rights for first-time renters in Montreal: rent increases, repairs, and what landlords can and can't do.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.tchncs.de/videos/watch/d7d5b093-3491-4bd5-8ab0-92cf783b1775",
            "note": "The Bonfire project on federated digital spaces built for mutual aid networks, as an alternative to running them on corporate group chats.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.osgeo.org/videos/watch/86a4f7b0-fbcd-4a98-b9d7-8ab9a98d4367",
            "note": "A FOSS4G talk on interactive open-source tools for visualizing climate risk, used in disaster-reduction programmes.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.apc.org/videos/watch/4001443d-9758-45f2-98d2-f9fe53167794",
            "note": "A four-minute APC short on where digital rights and environmental justice meet, with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tv.undersco.re/videos/watch/cb8fefbb-60a1-4475-aeff-1da8c93760e1",
            "note": "New Design Congress on the 'para-real': how decentralised networks of care form when official systems fail people.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/eb317ecf-4f68-4a9e-9135-33b0284916b7",
            "note": "An honest DIY test: can one solar panel on a shed roof run a home server rack, or does it just cost money?",
            "addedAt": 1792468565
          },
          {
            "id": "https://fair.tube/videos/watch/66affa20-2094-457c-bd85-8d8c50637a2f",
            "note": "A short documentary on co-creating climate resilience plans between residents and city administration over eight weeks, with captions.",
            "addedAt": 1792468565
          },
          {
            "id": "https://urbanists.video/videos/watch/a7c63ddd-29f3-4a5c-aa15-d2ef1b2b7039",
            "note": "An unedited interview with Move Minnesota's MJ Carpio on how transit advocates actually win changes in their city.",
            "addedAt": 1792468565
          }
        ]
      }
    },
    {
      "slug": "strange-machines",
      "list": {
        "v": 1,
        "name": "Strange Machines",
        "author": "Multiverse Video editors",
        "description": "Make unusual physical things and understand how they work.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://makertube.net/videos/watch/012c1f18-5e08-403e-af02-58cf2deedfe0",
            "note": "A hackerspace workshop on hardware hacking for absolute beginners: how to open a device, find its debug ports, and learn what's inside.",
            "addedAt": 1792468565
          },
          {
            "id": "https://cuddly.tube/videos/watch/1a077c7c-4f26-404e-8fcf-9ab701b199de",
            "note": "Lessons from building a networking stack for microcontrollers with 32 kB of RAM, in Go.",
            "addedAt": 1792468565
          },
          {
            "id": "https://framatube.org/videos/watch/1b7027e5-6e45-4876-9833-4778de60b44f",
            "note": "Nathan Proctor of the US PIRG on the right-to-repair fight and how copyright law (the DMCA) gets used to stop you fixing your own things.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/536b2ab8-8349-479f-b874-6babd38b3d8f",
            "note": "Crowd Supply's Teardown Sessions talks with Michael Altfield, maker of BusKill, a laptop kill-cord, about practical OpSec and privacy hardware.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/aa8863b9-b2e1-4acd-ac9e-e917e1ff5fb1",
            "note": "Two minutes from unboxing to running code: installing MicroPython on a tiny ESP32-C3 board.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tilvids.com/videos/watch/fdefceaf-3690-4458-8852-b08c363b02ef",
            "note": "Veronica Explains pushes back on tech's habit of shaming people's hardware and software choices: your tools are probably fine.",
            "addedAt": 1792468565
          },
          {
            "id": "https://videos.trom.tf/videos/watch/64d4b2b2-c5b3-4491-af8a-80d4f152c1f3",
            "note": "A Hackerspace Brussels talk on using free software to build your own autonomous robots.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/2b0d88b4-f767-448d-86fd-42edc3e96ab2",
            "note": "Planning an ESP32 project end to end and connecting it to Wi-Fi with MicroPython, including the parts that don't work the first time.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/d9fdc782-9019-473a-b1eb-0f7924b0d683",
            "note": "A walk through an EDM power-supply circuit, explaining how each section works and where it could fail.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/eb317ecf-4f68-4a9e-9135-33b0284916b7",
            "note": "An honest DIY test: can one solar panel on a shed roof run a home server rack, or does it just cost money?",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.curious.bio/videos/watch/f8c45af2-96ea-4c5c-9198-c08cd226a247",
            "note": "A talk on 3D printing with mycelium: growing structures from fungus instead of plastic.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.fenarinarsa.com/videos/watch/5052c72f-9d59-4299-9b3a-b3b29fc65e4f",
            "note": "A 2024 demo that squeezes astonishing effects out of a stock 8 MHz Atari STE: the demoscene's art of doing impossible things with old hardware.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.infosec.exchange/videos/watch/eea8df79-1558-4ab8-bea6-45ae79430aee",
            "note": "A step-by-step solve of a crackmes.one reverse-engineering challenge, narrated so you can follow the reasoning, not just the answer.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/37026fab-651d-41c3-ba93-bbb7d9d3c494",
            "note": "A Stargate-inspired 'Dial-Home Device' built from scratch: a beautifully unnecessary machine, documented build step by build step.",
            "addedAt": 1792468565
          }
        ]
      }
    },
    {
      "slug": "the-weird-internet",
      "list": {
        "v": 1,
        "name": "The Weird Internet",
        "author": "Multiverse Video editors",
        "description": "Celebrate creative computing, independent culture, and genuinely strange ideas.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://makertube.net/videos/watch/7ebdc562-2985-4de0-b262-5f07fc103fad",
            "note": "Artist bleeptrack's workshop on coding your own generative art with paper.js, from first shape to a piece that surprises you.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tilvids.com/videos/watch/fccf3369-f9b9-49f4-bd52-0a778d451f49",
            "note": "Build a chatbot character inside a Godot game that talks to a language model running on your own machine through Ollama.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.rhizome.org/videos/watch/5abcf089-0898-4d2b-a45d-65d02e39b69d",
            "note": "Rhizome's panel on the ethics of archiving digital folklore: memes, image macros, and who gets a say when the web's culture is preserved.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tubedu.org/videos/watch/79d4361a-1713-4d90-b1c8-7aa5bbbc9c93",
            "note": "Nine iterations of one creative-coding sketch in OPENRNDR, showing how an idea evolves rather than just the finished piece.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.blender.org/videos/watch/5ca2bd96-8de7-4cb2-af6c-b85201b3002b",
            "note": "From the Blender Conference 2026: procedural workflows with Gaussian splatting, the new way to turn photos into 3D scenes.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.rhizome.org/videos/watch/9b89b7ae-7a08-4db1-8c4d-5a9f60556795",
            "note": "Rhizome's Net Art Anthology on distribution and disappearance after 9/11: how net art changed as the web did. Captioned.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tube.waag.org/videos/watch/76ec6be9-502c-4a0d-98e1-a2c4f6991308",
            "note": "Artist Špela Petrič presents The Archive of In-Operables, made during a residency at Waag Futurelab: strange, thoughtful art at the edge of biology and tech.",
            "addedAt": 1792468565
          },
          {
            "id": "https://video.infiniteloop.tv/videos/watch/77212c40-bdcf-4073-a90a-df83d7b62417",
            "note": "A short Demoscene Report: what the demoscene released and celebrated this fortnight, from a long-running scener. Captioned.",
            "addedAt": 1792468565
          },
          {
            "id": "https://media.curious.bio/videos/watch/f8c45af2-96ea-4c5c-9198-c08cd226a247",
            "note": "A talk on 3D printing with mycelium: growing structures from fungus instead of plastic.",
            "addedAt": 1792468565
          },
          {
            "id": "https://peertube.fenarinarsa.com/videos/watch/5052c72f-9d59-4299-9b3a-b3b29fc65e4f",
            "note": "A 2024 demo that squeezes astonishing effects out of a stock 8 MHz Atari STE: the demoscene's art of doing impossible things with old hardware.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/37026fab-651d-41c3-ba93-bbb7d9d3c494",
            "note": "A Stargate-inspired 'Dial-Home Device' built from scratch: a beautifully unnecessary machine, documented build step by build step.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/9099cd77-e7d4-4e95-806f-badca0027e11",
            "note": "A review of Writing Interactive Fiction With Twine, a friendly on-ramp into making playable stories.",
            "addedAt": 1792468565
          }
        ]
      }
    },
    {
      "slug": "from-video-to-project",
      "list": {
        "v": 1,
        "name": "From Video to Project",
        "author": "Multiverse Video editors",
        "description": "Each video comes with something you can build or do next.",
        "updatedAt": 1792468565,
        "items": [
          {
            "id": "https://makertube.net/videos/watch/7ebdc562-2985-4de0-b262-5f07fc103fad",
            "note": "Artist bleeptrack's workshop on coding your own generative art with paper.js, from first shape to a piece that surprises you.",
            "addedAt": 1792468565
          },
          {
            "id": "https://tilvids.com/videos/watch/fccf3369-f9b9-49f4-bd52-0a778d451f49",
            "note": "Build a chatbot character inside a Godot game that talks to a language model running on your own machine through Ollama.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/aa8863b9-b2e1-4acd-ac9e-e917e1ff5fb1",
            "note": "Two minutes from unboxing to running code: installing MicroPython on a tiny ESP32-C3 board.",
            "addedAt": 1792468565
          },
          {
            "id": "https://makertube.net/videos/watch/2b0d88b4-f767-448d-86fd-42edc3e96ab2",
            "note": "Planning an ESP32 project end to end and connecting it to Wi-Fi with MicroPython, including the parts that don't work the first time.",
            "addedAt": 1792468565
          }
        ]
      }
    }
  ]
}
